import { Box, Typography } from '@mui/material';

const BookingInfoRow = ({ key, label, value, alignTop = false }: { key?: any, label: string, value: React.ReactNode, alignTop?: boolean }) => (
  <Box
    key={key}
    display="flex"
    alignItems={alignTop ? 'flex-start' : 'center'}
    mb={2}
    gap={{
      xs: 1,
      md: 0,
    }}>
    <Typography
      variant="body1"
      fontWeight={400}
      sx={{ flex: 1 }}
    >
      {label}
    </Typography>
    <Typography variant="body1" fontWeight={500} sx={{ flex: 2 }}>{value}</Typography>
  </Box>
);

export default BookingInfoRow; 